<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  GET_RECRUITMENT,
  RECRUITMENT_MUTATION_CREATE,
  RECRUITMENT_MUTATION_DELETE,
  RECRUITMENT_MUTATION_UPDATE,
} from '@/services/api/setting/employee/recruitment'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          inputName: 'locName',
          label: this.$t('setting.list.employeeSetting.recruitmentPlace'),
          placeholder: this.$t('setting.list.employeeSetting.recruitmentPlace'),
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          validation: [['required'], ['isUnique', this.data]],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          if (filter?.orderBy) {
            let objOrderBy = JSON.parse(filter.orderBy[0])
            let optOrderBy = {
              text: objOrderBy.name,
            }
            delete filter.orderBy[0]
            filter.orderBy[0] = JSON.stringify(optOrderBy)
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_RECRUITMENT,
            variables: {
              filter: filter,
            },
          })
          let self = this
          let result = res.data.employeeRecruitedAts.employeeRecruitedAts
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            } else if (item.hasRelation) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = true
            }
            result.data[index].name = item.text
          })

          self.data = result.data
          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: RECRUITMENT_MUTATION_CREATE,
            variables: {
              input: {
                text: data.locName,
              },
            },
          })
          let self = this
          let newData = res.data.createEmployeeRecruitedAt.employeeRecruitedAt
          newData.name = data.locName
          self.data.push(newData)

          return newData
        },
        update: async (name, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: RECRUITMENT_MUTATION_UPDATE,
            variables: {
              input: {
                oldValue: oldData.name,
                newValue: newData.locName,
              },
            },
          })
          let self = this
          let dataUpdateIndex = self.data.findIndex((item) => item.name == name)
          let result = res.data.updateEmployeeRecruitedAt.employeeRecruitedAt
          result.name = newData.locName
          self.data[dataUpdateIndex] = result
          return result
        },
        delete: async (name) => {
          const res = await this.$apollo.mutate({
            mutation: RECRUITMENT_MUTATION_DELETE,
            variables: {
              input: {
                text: name,
              },
            },
          })

          return res.data.deleteEmployeeRecruitedAt.isSuccessful
        },
      }
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{
        $t('setting.list.employeeSetting.recruitmentPlace')
      }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        :fields="fields"
        :apiClient="query"
        trackBy="text"
        :searchable="true"
        :isPredefined="true"
      />
    </div>
  </b-tab>
</template>
